var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2648",
    "data-name": "Group 2648",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 18,
    height: 18,
    fill: "#B4A085"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2647",
    "data-name": "Group 2647",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M17.438,6.751H11.25V.563A.562.562,0,0,0,10.688,0H7.313A.562.562,0,0,0,6.75.563V6.751H.563A.563.563,0,0,0,0,7.313v3.375a.563.563,0,0,0,.563.562H6.75v6.187A.562.562,0,0,0,7.313,18h3.375a.562.562,0,0,0,.562-.562V11.251h6.187A.562.562,0,0,0,18,10.688V7.313a.562.562,0,0,0-.562-.562",
    transform: "translate(0 -0.001)",
    fill: "#B4A085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPrimary);
export default __webpack_public_path__ + "static/media/plus_primary.bfbe51b263e5004e5ef5c7304f9adac7.svg";
export { ForwardRef as ReactComponent };